import { render, staticRenderFns } from "./JetArticleOptionsForm.vue?vue&type=template&id=002acb52"
import script from "./JetArticleOptionsForm.vue?vue&type=script&lang=ts"
export * from "./JetArticleOptionsForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports